// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom"; // Додаємо useNavigate
// import { useDispatch } from "react-redux"; // Додаємо useDispatch
// import { addFilter } from "../../function/filtersSlice"; // Імпортуємо дію для фільтра
// import WithFieldData from "../HOK/withFieldData";
// import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
// import css from "./main.module.css";

// const TopBooksNew = ({ products, setCartCounterC, setLikeCounterC }) => {
//   const [randomProduct, setRandomProduct] = useState(null);
//   const navigate = useNavigate(); // Ініціалізуємо навігацію
//   const dispatch = useDispatch(); // Ініціалізуємо dispatch

//   useEffect(() => {
//     if (products.length > 0) {
//       const randomIndex = Math.floor(Math.random() * products.length);
//       setRandomProduct(products[randomIndex]);
//     }
//   }, [products]);

//   const goToTopBooks = () => {
//     // Додаємо фільтр "ТОП книги" в Redux
//     dispatch(addFilter({ field: "top", value: "true" }));
//     // Перенаправляємо на сторінку каталогуі
//     navigate("/catalog");
//   };

//   return (
//     <div className={css.oneProdWrapNew}>
//       <p className={css.nameOfAcrAllTop} onClick={goToTopBooks}>
//         Топ продажу
//       </p>
//       {randomProduct && (
//         <SmallProductCartTop
//           el={randomProduct}
//           setCartCounterC={setCartCounterC}
//           setLikeCounterC={setLikeCounterC}
//         />
//       )}
//     </div>
//   );
// };

// export default WithFieldData("top", "product", "true")(TopBooksNew);
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addFilter } from "../../function/filtersSlice";
import WithFieldData from "../HOK/withFieldData";
import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
import css from "./main.module.css";
import { HandySvg } from "handy-svg";
import arrow from "../../svg/arrow.svg";

const TopBooksNew = ({ products, setCartCounterC, setLikeCounterC }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [startX, setStartX] = useState(null);
  const [endX, setEndX] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (products.length > 0) {
      setCurrentIndex(0);
    }
  }, [products]);

  const goToTopBooks = () => {
    dispatch(addFilter({ field: "top", value: "true" }));
    navigate("/catalog");
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % products.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? products.length - 1 : prev - 1));
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
    setEndX(null);
  };

  const handleTouchMove = (e) => {
    if (startX !== null) {
      setEndX(e.touches[0].clientX);
    }
  };

  const handleTouchEnd = () => {
    if (startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) handleNext();
      else if (delta < -50) handlePrev();
    }
    setStartX(null);
    setEndX(null);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX);
  };

  const handleMouseMove = (e) => {
    if (isDragging) {
      setEndX(e.clientX);
    }
  };

  const handleMouseUp = () => {
    if (isDragging && startX !== null && endX !== null) {
      const delta = startX - endX;
      if (delta > 50) handleNext();
      else if (delta < -50) handlePrev();
    }
    setIsDragging(false);
    setStartX(null);
    setEndX(null);
  };

  return (
    <div
      className={css.oneProdWrapNew}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      style={{ touchAction: "none", userSelect: "none" }}
    >
      <p className={css.nameOfAcrAllTop} onClick={goToTopBooks}>
        Топ продажу
      </p>

      {products.length > 0 && (
        <div className={css.sliderWrap}>
          <SmallProductCartTop
            el={products[currentIndex]}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <HandySvg
            src={arrow}
            className={css.arrovIconBanner}
            width="52"
            height="49.56"
            onClick={handleNext}
          />
        </div>
      )}
    </div>
  );
};

export default WithFieldData("top", "product", "true")(TopBooksNew);
